import React from 'react';
import { useCourse } from 'presentation/hooks/courses';

import './styles.scss';

interface IProps {
    setShowToroFormModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ToroLearnBuyFooter = ({ setShowToroFormModal }: IProps): JSX.Element => {
    const { course } = useCourse();

    if (!course) return <span></span>;

    return (
        <footer className="footer d-flex align-items-center fixed-bottom bg-news">
            <div className="footer-content container-fluid px-5 d-flex justify-content-center">
                <div className="footer-content-buy d-flex align-items-center">
                    <p className="text-gray-graphite mr-2">Cliente Toro investe melhor e ainda tem acesso gratuito a todos os cursos.</p>
                    <button className="btn btn-primary px-5" onClick={() => setShowToroFormModal(true)}>
                        <span className="px-2">Acesse grátis</span>
                    </button>
                </div>
            </div>
        </footer>
    );
};
